import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Conectividadvpn/comprobarDatosVPN`, method: 'POST', body: values, token: token})
}